import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import stripeConfig from 'config/stripe.json';

export function useLoadStripe(): (stripe: Stripe | null, accountId?: string | null) => Promise<Stripe> {
	const utilityContext = useUtilityContext();

	return async function loadStripeWrapper(stripe: Stripe | null, accountId?: string | null): Promise<Stripe> {
		// if we already have a stripe instance and no accountId is specified, return it
		if (stripe && !accountId) return stripe;

		// otherwise load stripe with the specified accountId
		const environment = utilityContext.environment.getEnvironment();
		const stripeInstance = accountId
			? await loadStripe(stripeConfig.key[environment], { stripeAccount: accountId })
			: stripe;
		if (!stripeInstance) throw new Error('Stripe instance not found');
		return stripeInstance;
	};
}
